import axiosInstance from '../axios/axiosInstance';
import { Category, Page } from '../model/response';
import { CategoryRequest, TableParams } from '../model/request';

export const findAllCategories = async () => {
  const { data } = await axiosInstance.get<Category[]>('categories', { params: { fromCMS: true } });
  return data;
};

export const getPageCategory = async (tableParams: TableParams, keyword: string) => {
  const params = {
    size: tableParams.pagination ? tableParams.pagination.pageSize : 10,
    page: tableParams.pagination && tableParams.pagination.current ? tableParams.pagination.current - 1 : 0,
    keyword,
    fromCMS: true,
  };
  const { data } = await axiosInstance.get<Page<Category>>('categories/page', {
    params: params,
  });
  return data;
};

export const findCategoryById = async (id: string) => {
  const { data } = await axiosInstance.get<Category>('categories/' + id);
  return data;
};

export const updateCategory = async (id: string, categoryRequest: CategoryRequest): Promise<void> => {
  await axiosInstance.put<string>(`categories/${id}`, categoryRequest);
};

export const createCategory = async (categoryRequest: CategoryRequest): Promise<string> => {
  const { data } = await axiosInstance.post<string>(`categories`, categoryRequest);
  return data;
};

export const deleteCategory = async (id: string) => {
  await axiosInstance.delete<void>('categories/' + id);
};
